import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {ReactComponent as ArrowIcon} from '../../../../../../../assets/arrowIcon.svg';
import {BoxList} from '../../../../../../../components/BoxList/BoxList';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {MatchInformationOverview as MatchInformationOverviewType} from '../../../../../../../types/shared-recruiting-types';

interface Props {
  onClick?: () => void;
  open: boolean;
  matchDataInfo?: MatchInformationOverviewType;
}

export const MatchInformationOverview = ({onClick, open, matchDataInfo}: Props) => {
  const {t} = useTranslation();

  const culturalMatchScore = matchDataInfo?.culturalMatchScore ?? 0;
  const jobMatchScore = matchDataInfo?.jobMatchScore ?? 0;
  const assessmentScore = matchDataInfo?.assessmentScore ?? 0;
  const overallScore = matchDataInfo?.overallScore ?? 0;

  const scoresList: string[] = [
    `${t('matchInformation.overview.culturalMatch')} ${culturalMatchScore}%`,
    `${t('matchInformation.overview.jobMatch')} ${jobMatchScore}%`,
    `${t('matchInformation.overview.testScore')} ${assessmentScore}%`,
  ];

  return (
    <Grid
      container
      sx={{
        minHeight: '121px',
        borderRadius: '10px',
        backgroundColor: orangeColors[5],
        padding: {xs: '12px', md: '20px'},
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
        <ArrowIcon
          fill={orangeColors[100]}
          style={{
            transform: open ? 'rotate(90deg)' : 'rotate(0)',
            transition: 'transform 0.2s ease-in-out',
            height: '30px',
            width: '30px',
          }}
        />
      </Box>
      <Grid
        container
        item
        xs={12}
        sx={{
          alignItems: 'center',
          justifyContent: {xs: 'center', sm: 'space-between'},
        }}
      >
        <Box
          display={'flex'}
          gap={1}
          sx={{
            flexDirection: {xs: 'column', sm: 'row'},
            alignItems: {xs: 'start', sm: 'center'},
          }}
          onClick={onClick}
        >
          <Box
            sx={{backgroundColor: '#B1D0D5'}}
            height={{xs: '137px', lg: '147px'}}
            width={{xs: '137px', lg: '147px'}}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            color={'black'}
            borderRadius={'50%'}
          >
            <Typography variant='h2' color={'primary'}>
              {overallScore}%
            </Typography>
          </Box>
          <Box>
            <Typography variant='body1'>{t('matchInformation.overview.title')}</Typography>
            <Typography
              variant='h1'
              sx={{
                fontSize: {xs: '24px', sm: '32px', lg: '40px'},
              }}
            >
              {t('matchInformation.overview.subtitle')}
            </Typography>
          </Box>
        </Box>

        <Box>
          <BoxList
            data={scoresList}
            onClick={onClick}
            sx={{
              padding: '16px 18px',
              marginTop: 2,
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
